module.exports = __webpack_public_path__ + "static/img/9.d0180db.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/zh/9.png
// module id = pZpZ
// module chunks = 0